import { render, staticRenderFns } from "./ClubHortensePhone.vue?vue&type=template&id=6a86581b&scoped=true&"
import script from "./ClubHortensePhone.vue?vue&type=script&lang=js&"
export * from "./ClubHortensePhone.vue?vue&type=script&lang=js&"
import style0 from "./ClubHortensePhone.vue?vue&type=style&index=0&id=6a86581b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a86581b",
  null
  
)

export default component.exports